import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddhoardingComponent } from './addhoarding/addhoarding.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {​​​​​​​​ MatDatepickerModule }​​​​​​​​ from'@angular/material/datepicker';
import {​​​​​​​​ MatInputModule }​​​​​​​​ from'@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmDialogModule } from '@app/module/confirm-dialog/confirm-dialog.module';
import { AgmCoreModule } from '@agm/core';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [AddhoardingComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,ConfirmDialogModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCraNVnfBrqtSGxkEqB0IIFCMDisxeS4r0',
      libraries: ['geometry', 'places']
    }),
    NgxSpinnerModule
  ]
})
export class AddhoardingModule { }
